const SolutionSection = () => {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="bg-white py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Label */}
        <p
          data-testid="solution-label"
          className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6"
        >
          La Solution
        </p>

        {/* Main Headline */}
        <h2
          data-testid="solution-headline"
          className="font-heading text-4xl sm:text-5xl font-light tracking-tight leading-tight text-[#0A0A0A] mb-8 max-w-3xl"
        >
          Votre marque là où elle compte.
          <br />
          <span className="italic">Dans la vie réelle.</span>
        </h2>

        <p className="font-body text-lg font-light leading-relaxed text-[#525252] max-w-2xl mb-16">
          Des diffuseurs de parfums haut de gamme installés dans des lieux à
          fort trafic. Une expérience olfactive au moment où vos clients en
          ont le plus envie.
        </p>

        {/* Bento Grid */}
        <div className="grid md:grid-cols-12 gap-4 md:gap-6">
          {/* Large Image Card - Gym */}
          <div
            data-testid="solution-card-gym"
            className="md:col-span-8 relative overflow-hidden group"
          >
            <div className="aspect-[16/10] relative">
              <img
                src="https://images.unsplash.com/photo-1758957646695-ec8bce3df462"
                alt="Salle de sport premium"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-8">
                <p className="font-body text-sm tracking-[0.15em] uppercase text-white/80 mb-2">
                  Salles de sport
                </p>
                <p className="font-heading text-2xl text-white">
                  Le moment clé après l'effort
                </p>
              </div>
            </div>
          </div>

          {/* Small Card - Stats */}
          <div
            data-testid="solution-card-stats"
            className="md:col-span-4 bg-[#FAFAFA] border border-[#E5E5E5] p-8 flex flex-col justify-center"
          >
            <p className="font-heading text-5xl lg:text-6xl text-[#0A0A0A] mb-4">
              7M
            </p>
            <p className="font-body text-base font-light text-[#525252]">
              adhérents en France fréquentent les salles de sport
            </p>
          </div>

          {/* Small Card - Feature */}
          <div
            data-testid="solution-card-feature"
            className="md:col-span-4 bg-[#0A0A0A] text-white p-8 flex flex-col justify-center"
          >
            <p className="font-body text-sm tracking-[0.15em] uppercase text-[#B89F7C] mb-4">
              Diffuseur intelligent
            </p>
            <p className="font-heading text-2xl leading-tight">
              Un geste simple,
              <br />
              une expérience immédiate
            </p>
          </div>

          {/* Large Image Card - Hotel */}
          <div
            data-testid="solution-card-hotel"
            className="md:col-span-8 relative overflow-hidden group"
          >
            <div className="aspect-[16/10] relative">
              <img
                src="https://images.pexels.com/photos/29649745/pexels-photo-29649745.jpeg"
                alt="Hall d'hôtel luxueux"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-8">
                <p className="font-body text-sm tracking-[0.15em] uppercase text-white/80 mb-2">
                  Hôtels & Coworking
                </p>
                <p className="font-heading text-2xl text-white">
                  Des environnements premium pour votre marque
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
